@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.lessee.title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.lessee.lessee_name' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.SubjName"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.lessee.lessee_inn' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.SubjInn"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.lessee.lessee_fullname' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.SubjFullname"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.lessee.lessee_phone_number' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.SubjPhone"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>
  </div>
</form>
